import React from "react";
import { Box, Typography, alpha, useTheme } from "@mui/material";
import { FiberManualRecord } from "@mui/icons-material";
import CustomCheckbox from "../../../../components/CustomForm/CustomCheckbox";

const DaySelector = ({
  daysOfWeek,
  selectedDays,
  weeklyAssignment,
  onDaySelect,
  disabled = false,
}) => {
  const theme = useTheme();
  const existingDays = weeklyAssignment?.map((job) => job.weekly_day) || [];

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, mb: 1.5 }}>
      {daysOfWeek.map((day) => {
        const isExistingDay = existingDays.includes(day);
        const isSelected = selectedDays.includes(day);
        const slotCount =
          weeklyAssignment?.filter((job) => job.weekly_day === day).length || 0;

        return (
          <Box
            key={day}
            sx={{
              display: "flex",
              alignItems: "center",
              border: "1px solid",
              borderColor: isSelected
                ? theme.palette.primary.main
                : alpha(theme.palette.divider, 0.2),
              borderRadius: "6px",
              bgcolor: isSelected
                ? alpha(theme.palette.primary.main, 0.04)
                : "#FFFFFF",
              transition: "all 0.15s ease",
              opacity: disabled ? 0.6 : isExistingDay && !isSelected ? 0.5 : 1,
              cursor: disabled ? "not-allowed" : "pointer",
              pointerEvents: disabled ? "none" : "auto",
              px: 0.5,
              "&:hover": disabled
                ? {}
                : {
                    borderColor: isSelected
                      ? theme.palette.primary.main
                      : alpha(theme.palette.primary.main, 0.3),
                    bgcolor: isSelected
                      ? alpha(theme.palette.primary.main, 0.06)
                      : alpha(theme.palette.primary.main, 0.02),
                  },
            }}
            onClick={() => {
              if (!disabled) onDaySelect(day);
            }}
          >
            <CustomCheckbox isInitiallyChecked={isSelected} disabled={disabled} />

            <Typography
              sx={{
                fontSize: "0.7rem",
                fontWeight: 600,
                pr: 0.75,
                color: isSelected ? theme.palette.primary.main : "#1A1A2E",
                letterSpacing: "0.2px",
              }}
            >
              {day}
            </Typography>

            {isExistingDay && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mr: 0.5 }}>
                <FiberManualRecord
                  sx={{
                    fontSize: 5,
                    color: isSelected ? theme.palette.success.main : "#F59E0B",
                  }}
                />
                {slotCount > 1 && (
                  <Typography
                    sx={{
                      fontSize: "0.5rem",
                      fontWeight: 700,
                      color: alpha(theme.palette.text.secondary, 0.4),
                    }}
                  >
                    {slotCount}
                  </Typography>
                )}
              </Box>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default DaySelector;